import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { PayoutConfig } from '../../../../model/payoutConfig';

@Component({
    selector: 'leader-component',
    templateUrl: 'leader-component.html'
})
export class LeaderComponent {
    @Input() leaders: Map<number, any[]>;
    @Input() rodeoEvent: RodeoEvent;
    @Input() selectedRun: RodeoEventRun;

    _leaderModes: PayoutConfig[];
    leaderMode: PayoutConfig;
    timeOffset: number = .1;
    showTotalValue: boolean = false;

    @Input()
    set leaderModes(modes: PayoutConfig[]) {
        this._leaderModes = modes;

        if (this.rodeoEvent) {
            this.timeOffset = this.rodeoEvent.configuration.runs.scoreValue && !this.rodeoEvent.configuration.runs.timeValue ? .5 : .1;
        }

        if (this.leaderMode)
            this.leaderMode = this._leaderModes.filter(x => x.name == this.leaderMode.name)[0];

        if (!this.leaderMode) {
            this.leaderMode = this._leaderModes[0];
        }

        this.leaderModeSelected.emit(this.leaderMode);
        this.leaderModeUpdated();
    }
    get leaderModes() {
        return this._leaderModes;
    }

    @Input()
    set selectedMode(mode: PayoutConfig) {
        this.leaderModeSelected.emit(mode);
        this.leaderMode = mode;
        this.leaderModeUpdated();
    }

    @Output() leaderModeSelected = new EventEmitter<PayoutConfig>();

    topPlaces: number = 5;

    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();

    constructor() { }

    updateLeaderMode() {
        this.leaderModeSelected.emit(this.leaderMode);
        this.leaderModeUpdated();
    }

    leaderModeUpdated() {
        if (this.rodeoEvent) {
            if (this.rodeoEvent.configuration.runs.scoreValue && !this.rodeoEvent.configuration.runs.timeValue)
                this.timeOffset = .5;
            else
                this.timeOffset = +(1 / Math.pow(10, this.rodeoEvent.configuration.runs.decimalPlaces)).toFixed(this.rodeoEvent.configuration.runs.decimalPlaces);
        }
            
        if (this.leaderMode.isAverage || this.leaderMode.isAggregate)
            this.showTotalValue = true;
        else
            this.showTotalValue = false;
    }

    matchLeaderModes(a: PayoutConfig, b:PayoutConfig) {
        return a.id == b.id;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/scoring/leader-component.ts